import { useNavigate } from "react-router";
import DashboardCard from '../common/DashboardCard';
import DashboardCardRow from '../common/DashboardCardRow';
import { Box, Typography, Button, Stack } from '@mui/material';
import HiveIcon from '@mui/icons-material/Hive';
import MapIcon from '@mui/icons-material/Map';
import TimelineIcon from '@mui/icons-material/Timeline';
import { formatCurrency, formatNumber } from 'utils/formatUtils';

function PartnerChargingNetwork(props: any) {
    const dashboardInfo = props.dashboardInfo;
    const navigate = useNavigate();

    return (
        <DashboardCard
            title="Partner Charging Network"
            icon={<HiveIcon />}
            actions={
                <Button
                    startIcon={<MapIcon />}
                    onClick={() => navigate("/share/business/charging-partners/map")}
                >
                    View Network Map
                </Button>
            }
        >
            <Stack spacing={1}>
                <DashboardCardRow
                    title="Account Balance"
                    value={formatCurrency(dashboardInfo.currentBalance)}
                />
                <DashboardCardRow
                    title="Partners in Network"
                    value={formatNumber(dashboardInfo.businessesInPCN)}
                />
                <DashboardCardRow
                    title="Charge Points in Network"
                    value={formatNumber(dashboardInfo.countChargePointsInNetwork)}
                />
                <DashboardCardRow
                    title="Partner Since"
                    value={dashboardInfo.partnerChargingNetworkSubscriptionSince}
                />
                <DashboardCardRow
                    title="Business Code"
                    value={dashboardInfo.businessCode}
                />
            </Stack>
        </DashboardCard>
    );
}

export default PartnerChargingNetwork;
